import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { useTheme } from "@/components/ThemeProvider";

export function AuthLayout({ title, subtitle, children, footer }) {
  const { theme } = useTheme();
  const brand = theme?.product_display_name || "Quanta";
  const tagline = theme?.tagline || "Your day, understood.";
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="brand-navy-gradient relative hidden overflow-hidden text-white lg:flex lg:flex-col lg:justify-between lg:p-12">
        <div className="absolute inset-0 dot-grid opacity-40" />
        <div className="relative">
          <Logo variant="dark" size="md" brandName={brand} logoUrl={theme?.logo_reversed_url || theme?.logo_primary_url} />
        </div>
        <div className="relative max-w-md">
          <div
            className="text-xs font-medium uppercase tracking-widest"
            style={{ color: "var(--quanta-cyan)" }}
            data-testid="auth-tagline"
          >
            {tagline}
          </div>
          <div className="mt-3 font-display text-3xl font-semibold leading-tight" data-testid="auth-hero">
            Time intelligence for modern teams.
          </div>
          <p className="mt-4 text-sm text-white/70">
            Time-tracking with hardened auth on day one. Time moves
            forward. So do great teams.
          </p>
        </div>
        <div className="relative text-xs text-white/50" data-testid="auth-footer">
          © {new Date().getFullYear()} {brand}. {tagline}
        </div>
      </div>

      <div className="flex items-center justify-center bg-background px-6 py-12">
        <div className="w-full max-w-md">
          <div className="mb-8 lg:hidden">
            <Logo size="md" brandName={brand} logoUrl={theme?.logo_primary_url} />
          </div>
          <div className="mb-6">
            <h1 className="font-display text-3xl font-semibold text-primary" data-testid="auth-title">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
          </div>
          {children}
          {footer && <div className="mt-8 text-sm text-muted-foreground">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export function AuthLink({ to, children, ...rest }) {
  return (
    <Link to={to} className="font-medium text-secondary hover:underline" {...rest}>
      {children}
    </Link>
  );
}
